import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {StateWithCategory} from '../store/custom-category-state';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadCategory} from '../store/actions/custom-category.action';

@Injectable({
  providedIn: 'root'
})
export class CustomCategoryService {

  constructor(protected store: Store<StateWithCategory>, protected router: Router, protected route: ActivatedRoute) {
  }

  loadCategory(code: string): void {
    this.store.dispatch(
      new LoadCategory({
        code
      }),
    );
  }
}
